/* ────────────────────────────────────────────────────────────────────
   Main collection product grid — sort handler.
   On <select> change, updates URL `?sort_by=` and reloads.
   ──────────────────────────────────────────────────────────────────── */
(function () {
  'use strict';
  if (window.__dahabeyaCollectionSortInit) return;
  window.__dahabeyaCollectionSortInit = true;

  document.querySelectorAll('[data-sort-select]').forEach(function (select) {
    select.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', this.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });
})();
